import { createAsyncThunk, createSlice, nanoid } from "@reduxjs/toolkit";
import FirmalarRoutePoints from "../../utils/firmalarRoutePoints";
import axios from "axios";
import { showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {
    //! firmalar listesi
    companyList:[],

    //! firma arama inputu
    firmaSearch: "",

    //! firma bilgileri
    firmaValues: {
        companyName:"",
        companyPhone:"",
        companyMail:"",
        companyTaxOffice:"",
        companyTaxNo:"",
        companyAddress:"",
        companyCityAndTown:"",
    },

    //! yetkili bilgileri
    yetkiliBilgileriValues:{
        officialName:"",
        officialPhone:"",
        officialMail:""
    },

    //! yükleme/boşaltma noktası
    routePoints:[
        {
            id:nanoid(),
            addressName:"",
            address:"",
            googleAddress: "",
            cityAndTown:"",
            routeLocation:"",
            storageOfficialPhone:"",
            storageOfficialName:"",
            lat: null,
            lng:null
        }
    ],
 
    
    selectMapLatLng:null,
    firmaSelectRouteForMap:null,

    updatedFirmalarimData:null,

    //! detay açık kapalı
    isDetailOpen:false,
    //! seçilen firma
    selectedCompanyDetail:null,

    getIsLoading:false,
    getIsError:false,

    deleteIsLoading:false,
    deleteIsError:false,

    isLoading:false,
    isError:false
}

//! firma add
export const firmaEkle = createAsyncThunk("firmaEkle", async(param, thunkApi) => {
    try{

      const {routePoints, firma, yetkili, ...others} = param
      const newParam = {
        ...others, 
        yetkili:{...yetkili, officialPhone: yetkili?.officialPhone?.startsWith("90") ? yetkili?.officialPhone?.slice(2) : yetkili?.officialPhone}, 
        firma:{...firma, companyPhone: firma?.companyPhone?.startsWith("90") ? firma?.companyPhone?.slice(2) : firma?.companyPhone, companyCityAndTown:firma?.companyCityAndTown?.location} , 
        routePoints: routePoints.map((item)=>{ return {...item, lat: String(item?.lat), lng: String(item?.lng), storageOfficialPhone: item?.storageOfficialPhone?.startsWith("90") ? item?.storageOfficialPhone?.slice(2) : item?.storageOfficialPhone, cityAndTown:item?.cityAndTown?.location}})
      }
      
      const {data} = await axiosInstance.post(`/Firmas/Add`,newParam)
      
      if(data.statusCode === 200){
        thunkApi.dispatch(showModal(null))
        thunkApi.dispatch(clearWithoutList())
      }

      return data.data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! firma get
  export const firmalarimGet = createAsyncThunk("firmalarimGet", async(query = "", thunkApi) => {
    try{
  
      const {data} = await axiosInstance.get(`/Firmas/GetAll?FirmaAdi=${query}`)
      
      return data.data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! firma delete
  export const firmalarimDelete = createAsyncThunk("firmalarimDelete", async(query, thunkApi) => {
    try{
  
      const {data} = await axiosInstance.post(`/Firmas/Delete?Id=${query}`, "_")
      if(data.statusCode === 200){
        
      }
      return data.data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

//! firma update
export const firmalarimUpdate = createAsyncThunk("firmalarimUpdate", async(param, thunkApi) => {
  try{

    const {companyCity, companyTown, routePoints, ...others} = param
    const newParam = {...others, 
      companyCity: companyCity?.value === undefined ? companyCity : companyCity?.value, 
      companyTown: companyTown?.town === undefined ? companyTown : companyTown?.town,
      routePoints: routePoints?.map((item) => ({...item, lat: String(item?.lat), lng: String(item?.lng), cityAndTown:item?.cityAndTown?.location || item?.cityAndTown })) 
    }
    const {data} = await axiosInstance.post(`/Firmas/Update`, newParam)

    if(data.statusCode === 200){
        thunkApi.dispatch(setIsDetailOpen())
    }
    
    return data.data
  }catch(error){
    return thunkApi.rejectWithValue(error)
  }
})

const firmaSlice = createSlice({
    name:"firmaSlice",
    initialState,
    reducers:{
        //! firma adına göre arama
        setFirmaSearch: (state, action) => {
            state.firmaSearch = action.payload
        },
        //! firma bilgileri
        setFirmaValues: (state, action) => {
            const {keyData, value} = action.payload
            state.firmaValues = {...state.firmaValues, [keyData]:value}
        },
        //!yetkili bilgileri
        setYetkiliBilgileriValues: (state, action) => {
            const {keyData, value} = action.payload
            state.yetkiliBilgileriValues = {...state.yetkiliBilgileriValues, [keyData]:value}
        },
        //! firma bilgileri
        addFirmaRoutePoints: (state) => {
            const newRoute = {...FirmalarRoutePoints, id: nanoid()}
            state.routePoints = [...state.routePoints, newRoute]
        },
        //! rota bilgileri
        setFirmaRoutePoints: (state, action) => {
            state.routePoints = state?.routePoints?.map((item) => {
                if(item?.id === action.payload.id){
                    return { ...item, ...action.payload};
                }else{
                    return item
                }
            })
        },
        //! rota bilgileri sil
        deleteFirmaRoutePoints:(state, action) => {
            state.routePoints = state.routePoints.filter(
                (item) => item.id !== action.payload
            );
        },
        //! firma yetkili ve depo yetkilisi
        updateFirstStorageInfo: (state, action) => {
          const {officialPhone, officialName} = action.payload
          
          if (state.routePoints.length > 0) {
            state.routePoints[0].storageOfficialPhone = officialPhone;
            state.routePoints[0].storageOfficialName = officialName;
          }
        },
        //! seçili firmanın detayı
        setSelectedCompanyDetail: (state, action) => {
          state.selectedCompanyDetail = action.payload
        },
        //! güncelleme ekranı
        setIsDetailOpen: (state) => {
          state.isDetailOpen = !state.isDetailOpen
        },

        //! güncellenecek verileri atama
        setUpdatedFirmalarimData: (state, action) => {
          state.updatedFirmalarimData = action.payload
        },
        //! firma bilgileri update
        updateFirmaValues: (state, action) => {
          const {keyData, value} = action.payload
          state.updatedFirmalarimData = {...state.updatedFirmalarimData, [keyData]: value}
        },
        //! yetkili bilgileri update
        updateYetkiliValues: (state, action) => {
          const {keyData, value} = action.payload
          state.updatedFirmalarimData = {...state.updatedFirmalarimData, yetkili:{...state.updatedFirmalarimData.yetkili, [keyData]: value}}
        },

        //! rota bilgileri update
        updateRoutePoints: (state, action) => {
          state.updatedFirmalarimData = {...state.updatedFirmalarimData, routePoints: state.updatedFirmalarimData.routePoints.map((item)=>{
            if(item.id === action.payload.id){
              return {...item, ...action.payload}
            }else{
              return item
            }
          })}
        },
        //! harita seçilen nokta
        setSelectMapLatLng: (state, action) => {
          state.selectMapLatLng = action.payload
        },
        //! harita seçilen rota
        setFirmaSelectRouteForMap: (state, action) => {
          state.firmaSelectRouteForMap = action.payload
        },


        clearWithoutList:(state)=> {
            const companyList = state.companyList
            return {...initialState, companyList}
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(firmaEkle.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(firmaEkle.fulfilled, (state, action) => {
            state.isLoading = false;
            state.companyList = [...state.companyList, {...action.payload, routePoints:action.payload.routePoints.$values}]
        })
        .addCase(firmaEkle.rejected, (state) => {
            state.isError = true
            state.isLoading = false;
        })

        .addCase(firmalarimGet.pending, (state) => {
            state.getIsLoading = true;
        })
        .addCase(firmalarimGet.fulfilled, (state, action) => {
            state.getIsLoading = false;
            state.companyList = action.payload.$values.map((item)=>{
                return{ ...item, routePoints: item.routePoints.$values }
            })
        })
        .addCase(firmalarimGet.rejected, (state) => {
            state.getIsError = true
            state.getIsLoading = false;
        })

        .addCase(firmalarimDelete.pending, (state) => {
            state.deleteIsLoading = true;
        })
        .addCase(firmalarimDelete.fulfilled, (state, action) => {
            state.deleteIsLoading = false;
            state.companyList = state.companyList.filter(
                (item) => item.id !== action.payload.id
            );
        })
        .addCase(firmalarimDelete.rejected, (state) => {
            state.deleteIsError = true
            state.deleteIsLoading = false;
        })

        .addCase(firmalarimUpdate.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(firmalarimUpdate.fulfilled, (state, action) => {
            state.isLoading = false;
            state.selectedCompanyDetail = { ...action.payload, routePoints: action.payload.routePoints.$values }
        })
        .addCase(firmalarimUpdate.rejected, (state) => {
            state.isError = true
            state.isLoading = false;
        })
    }
})

export const {setSelectMapLatLng, setFirmaSelectRouteForMap, updateYetkiliValues, updateRoutePoints, updateFirmaValues, setUpdatedFirmalarimData, setIsDetailOpen, setSelectedCompanyDetail, updateFirstStorageInfo, clearWithoutList, deleteFirmaRoutePoints, setFirmaSearch, setFirmaValues, setYetkiliBilgileriValues, addFirmaRoutePoints, setFirmaRoutePoints} = firmaSlice.actions
export default firmaSlice.reducer